import { HostLegacy } from "@silvertours/front-legacy-entities";
import { usePath } from "./usePath";
var join = function(baseUrl, path) {
    var delimiter = path.indexOf("/") === 0 ? "" : "/";
    return "".concat(baseUrl).concat(delimiter).concat(path);
};
var useDocumentUrls = function() {
    var ref = HostLegacy.useHost(), alternativeBaseUrls = ref.alternativeBaseUrls, baseUrl = ref.baseUrl;
    var ref1 = usePath(), current = ref1.current, alternatives = ref1.alternatives;
    return {
        canonicalUrl: {
            rel: "canonical",
            href: join(baseUrl, current)
        },
        hreflangUrls: alternatives.map(function(param) {
            var locale = param.locale, path = param.path;
            return {
                hrefLang: locale,
                href: join(alternativeBaseUrls[locale], path),
                rel: "alternate"
            };
        })
    };
};
export { useDocumentUrls };
